import React from 'react';

/**
 * ResumeEmptyShell — rendered by ResumePreview when resumeData is null or all sections are empty.
 *
 * Architecture principle: the renderer owns empty state.
 * React passes null → renderer decides what to draw.
 * No fake placeholder objects in App.js or ChatPage.
 *
 * Sprint 1.2.2 — Document Session architecture.
 */
export default function ResumeEmptyShell({ accentColor = '#1D9BF0', fontScale = 1 }) {
  return (
    <div style={{
      width: '100%',
      minHeight: '600px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 24px',
      background: '#fafafa',
      fontFamily: "'Inter', sans-serif",
      color: '#1e293b',
      boxSizing: 'border-box',
    }}>
      <div style={{
        background: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: 16,
        padding: '32px 24px',
        maxWidth: 360,
        width: '100%',
        boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}>
        {/* Sparkles Icon */}
        <div style={{
          width: 40, height: 40, borderRadius: 10,
          background: 'rgba(29, 155, 240, 0.08)',
          border: '1px solid rgba(29, 155, 240, 0.15)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#1D9BF0', marginBottom: 16
        }}>
          <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09Z" />
          </svg>
        </div>

        <span style={{ fontSize: 9.5, fontWeight: 800, color: '#1D9BF0', textTransform: 'uppercase', letterSpacing: '0.8px' }}>
          Live Preview
        </span>
        <h3 style={{ fontSize: 15, fontWeight: 800, color: '#0f172a', marginTop: 6, marginBottom: 8 }}>
          Empty Resume Canvas
        </h3>
        <p style={{ fontSize: 11, color: '#64748b', lineHeight: '1.5', marginBottom: 20 }}>
          Your formatted resume will render here as you chat. Start typing in the Coach panel to add your name, experience, and other details.
        </p>

        <div style={{ width: '100%', textAlign: 'left', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 10.5 }}>
            <span>💬</span>
            <span style={{ color: '#334155', fontWeight: 600 }}>Chat with AI to generate sections</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 10.5 }}>
            <span>📤</span>
            <span style={{ color: '#334155', fontWeight: 600 }}>Import existing file to optimize</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 10.5 }}>
            <span>🎨</span>
            <span style={{ color: '#334155', fontWeight: 600 }}>Switch templates instantly</span>
          </div>
        </div>
      </div>
    </div>
  );
}
